import React from "react"
import { createPortal } from "react-dom"
import { useNavContext } from "../contexts/navContext"
import { Link } from "react-router-dom"

export default function MobileNav() {
  const toggler = useNavContext()
  return createPortal(
    <nav className={toggler.toggle ? "mobile-nav tl" : "mobile-nav tr"}>
      <ul>
        <li className="mb-4">
          {" "}
          <Link to="/">
            <i className="fas fa-home"></i>
            <span>Home</span>
          </Link>{" "}
        </li>
        <li className="mb-4">
          <Link to="/about">
            <i className="fas fa-address-card"></i>
            <span>About</span>
          </Link>
        </li>
        <li className="mb-4">
          <Link to="/portfolio">
            <i className="fas fa-briefcase"></i>
            <span>Portfolio</span>
          </Link>
        </li>
        <li className="mb-4">
          <Link to="/contact">
            <i className="fas fa-comment-alt"></i>
            <span>Contact</span>
          </Link>
        </li>
      </ul>

      <Link to="/portfolio" className="btn-custom mt-2">
        Explore ➜
      </Link>
    </nav>,
    document.body
  )
}
